import { Injectable } from '@angular/core';

export enum ReflowType {
    read,
    write
}
export type ReflowFinalize = () => ReflowOp | ReflowOp[] | null | undefined;
export type ReflowInitiate = (m?: any) => ReflowOp | ReflowOp[] | null | undefined;

export abstract class ReflowOp {
    type!: ReflowType;
    clone(lottery?: boolean): ReflowOp {
        return this.type === ReflowType.read
            ? new ReflowRead(this.action, lottery == null ? this.lottery : lottery)
            : new ReflowWrite(this.action, lottery == null ? this.lottery : lottery);
    }
    constructor(
        public action: ReflowInitiate | ReflowFinalize,
        public lottery: boolean = false
    ) {}
}
export class ReflowRead extends ReflowOp {
    type = ReflowType.read;
}
export class ReflowWrite extends ReflowOp {
    type = ReflowType.write;
}

@Injectable()
export class ReflowAggregatorService {
    constructor() {}

    private phase = ReflowType.read;
    private queueDrain: Promise<void> | null = null;
    private queues: { [id: number]: ReflowOp[] } = {
        [ReflowType.read]: [],
        [ReflowType.write]: []
    };
    add(...ops: ReflowOp[]) {
        for (const op of ops) {
            this.queues[op.type].push(op);
            if (!this.queueDrain) {
                this.queueDrain = this.drainQueueLater();
            }
        }
    }
    addLater(...ops: ReflowOp[]) {
        return (_m: any) => {
            for (const op of ops) {
                this.add(op);
            }
        };
    }

    private drainQueueLater() {
        return Promise.resolve().then(() => {
            this.queueDrain = null;
            const q = this.queues[this.phase].filter(op => !op.lottery);
            const lq = this.queues[this.phase].filter(op => op.lottery);
            const nextPhase = this.phase === ReflowType.read ? ReflowType.write : ReflowType.read;
            if (lq.length) {
                q.push(lq[randIndex(lq)]);
            }
            this.queues[this.phase] = [];
            q.forEach(f => {
                let next = f.action();
                if (next) {
                    if (!Array.isArray(next)) {
                        next = [next];
                    }
                    for (const n of next) {
                        if (n.type === this.phase) {
                            throw new Error(
                                `ReflowOp returned from a ${ReflowType[n.type]} ` +
                                    `should be a ${ReflowType[nextPhase]}`
                            );
                        }
                        this.queues[n.type].push(n);
                    }
                }
            });
            if (this.queues[nextPhase].length) {
                this.phase = nextPhase;
                this.queueDrain = this.drainQueueLater();
            }
        });

        function randIndex(queue: any[]) {
            return Math.floor(Math.random() * queue.length) % queue.length;
        }
    }
}
